import React from "react";
import { Link } from "react-router-dom";
import { CATEGORIES } from "../../lib/utils-cynos";

const cat = (slug) => CATEGORIES.find((category) => category.slug === slug);

const CategorySection = ({ images }) => (
  <section className="px-4 py-7 md:px-8 md:py-10 lg:px-12" data-testid="categories-section">
    <div className="mb-4 flex items-end justify-between md:mb-6">
      <div>
        <span className="font-mono text-[10px] uppercase tracking-[0.26em] text-cynos-red md:text-xs">Shop By</span>
        <h2 className="mt-2 font-anton text-[clamp(2rem,8vw,3rem)] uppercase leading-none md:text-5xl">Categories.</h2>
      </div>
    </div>
    <div className="grid h-auto grid-cols-2 gap-2 md:h-[480px] md:grid-cols-6 md:grid-rows-2 md:gap-3">
      <CategoryTile cat={cat("oversized")} img={images.oversized} className="col-span-2 md:col-span-3 md:row-span-2" big />
      <CategoryTile cat={cat("men")} img={images.men} className="col-span-1 md:col-span-2 md:row-span-1" />
      <CategoryTile cat={cat("anime")} img={images.anime} className="col-span-1 md:col-span-1 md:row-span-1" />
      <CategoryTile cat={cat("women")} img={images.women} className="col-span-1 md:col-span-1 md:row-span-1" />
      <CategoryTile cat={cat("unisex")} img={images.graphic || images.oversized} className="col-span-1 md:col-span-2 md:row-span-1" />
      <CategoryTile cat={cat("graphic")} img={images.graphic} className="col-span-2 md:hidden" />
    </div>
  </section>
);

const CategoryTile = ({ cat, img, className = "", big = false }) => (
  cat ? (
  <Link
    to={`/shop?category=${cat.slug}`}
    className={`group relative overflow-hidden rounded-[8px] border border-white/10 bg-cynos-surface ${big ? "min-h-[260px]" : "min-h-[170px]"} md:min-h-0 ${className}`}
    data-testid={`cat-tile-${cat.slug}`}
  >
    <img src={img} alt={cat.label} className="absolute inset-0 h-full w-full object-cover zoom-on-hover" loading="lazy" decoding="async" sizes={big ? "(max-width: 768px) 100vw, 50vw" : "(max-width: 768px) 50vw, 25vw"} />
    <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent" />
    <div className="absolute bottom-0 left-0 p-4 md:p-5">
      <span className="font-mono text-[10px] uppercase tracking-[0.18em] text-cynos-red md:text-xs">Shop</span>
      <div className={`mt-1 font-anton uppercase leading-none ${big ? "text-[clamp(2.4rem,10vw,3.75rem)] md:text-6xl" : "text-3xl md:text-4xl"}`}>{cat.label}</div>
    </div>
  </Link>
  ) : null
);

export default CategorySection;
